import { createSlice } from "@reduxjs/toolkit";

export const DarkModeTogglerSlice = createSlice({
  name: "DarkModeToggler",
  initialState: {
    darkMode: true,
    css: {
      cardBackground: "bg-Card-Dark-Mode",
      navbarBackgroundColor: "bg-Navbar-Dark-Mode",
      headerColor: "text-Header-Dark-Mode",
      textColor: "text-Dark-Mode",
      textLightColor: "textLight-Dark-Mode",
      textFormAlertColor: "text-Form-Alert-Dark-Mode",
      backGroundColor: "bg-Dark-Mode",
      accountPageBackground: "bg-Account-page-Dark-Mode",
    },
  },
  reducers: {
    BrightToggler: (state) => {
      if (state.darkMode) {
        state.darkMode = false;
        state.css.cardBackground = "bg-Card-Light-Mode";
        state.css.navbarBackgroundColor = "bg-Navbar-Light-Mode";
        state.css.headerColor = "text-Header-Light-Mode";
        state.css.textColor = "text-Light-Mode";
        state.css.textLightColor = "textLight-Light-Mode";
        state.css.textFormAlertColor = "text-Form-Alert-Light-Mode";
        state.css.backGroundColor = "bg-Light-Mode";
        state.css.accountPageBackground = "bg-Account-page-Light-Mode";
      }
    },

    NightToggle: (state) => {
      if (state.darkMode === false) {
        state.darkMode = true;
        state.css.cardBackground = "bg-Card-Dark-Mode";
        state.css.navbarBackgroundColor = "bg-Navbar-Dark-Mode";
        state.css.headerColor = "text-Header-Dark-Mode";
        state.css.textColor = "text-Dark-Mode";
        state.css.textLightColor = "textLight-Dark-Mode";
        state.css.textFormAlertColor = "text-Form-Alert-Dark-Mode";
        state.css.backGroundColor = "bg-Dark-Mode";
        state.css.accountPageBackground = "bg-Account-page-Dark-Mode";
      }
    },
  },
});

export const { BrightToggler, NightToggle } = DarkModeTogglerSlice.actions;

export default DarkModeTogglerSlice.reducer;
